import PrivacyContent from '../../../components/PrivacyAndTerms/PrivacyContent';

import Container from './Container';

function Privacy() {
  return (
    <Container>
      <PrivacyContent />
    </Container>
  );
}

export default Privacy;
